(function() {
  function updateTextImageMargin() {
    const headerDecoration = document.querySelector('.main-header__decoration');
    const textImage = document.querySelector('.text-image');

    if (!headerDecoration || !textImage) return;

    // Get the actual height of the header decoration
    const decorationHeight = headerDecoration.offsetHeight;

    // Apply it as margin-top to the text-image section
    textImage.style.marginTop = `${decorationHeight}px`;
  }

  // Update on DOM load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateTextImageMargin);
  } else {
    updateTextImageMargin();
  }

  // Update on window resize with debounce to prevent excessive calls
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateTextImageMargin, 100);
  });

  // Update when images load (in case they affect layout)
  window.addEventListener('load', updateTextImageMargin);
})();
